<template lang="pug">
        game-preview-settings
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}
                span(slot="value") {{ parameters.difficult.name }}
            game-preview-setting(v-if="parameters.timeLimit")
                span(slot="name") {{ $i18n.t('progress.progress_preview_timeLimit') }}
                span(slot="value") {{ limitName }}
            game-preview-setting(v-if="parameters.displaySpeed")
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_displaySpeed') }}
                span(slot="value") {{ speedName }}
</template>

<script>
    import GamePreviewSettings from './GamePreviewSettings.vue';
    import GamePreviewSetting from './GamePreviewSetting.vue';
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        props: {
            parameters: Object,
            exerciseId: [Number, String],
            type: String,
        },
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting,
        },
        computed: {
            limitName() {
                return (
                    this.parameters.timeLimit +
                    ' ' +
                    this.$i18n.tc('trainer.trainer_gamePreview_timeParamMinuteDeclination', this.parameters.timeLimit)
                );
            },
            speedName() {
                return (
                    this.parameters.displaySpeed +
                    ' ' +
                    this.$i18n.tc('olympiads.olympiads_timeDeclination_seconds', this.parameters.displaySpeed)
                );
            },
        },
    };
</script>
